// composables/useSchemaOrg.ts
import { ref, watch } from 'vue';

export function useSchemaOrg() {
  const schemaData = ref<any[]>([]);

  const updateSchema = (data: any) => {
    try {
      // 确保 data 是数组
      const dataArray = Array.isArray(data) ? data : [data];

      dataArray.forEach((item: any) => {
        // 验证数据
        if (!item['@context'] || !item['@type']) {
          console.warn('Schema数据缺少必要属性');
          return;
        }

        // 处理日期
        if (item.datePublished instanceof Date) {
          item.datePublished = item.datePublished.toISOString();
        }
        if (item.dateModified instanceof Date) {
          item.dateModified = item.dateModified.toISOString();
        }
      });

      // 更新数据
      schemaData.value = dataArray;

      // 更新DOM
      const oldScript = document.querySelector('script[type="application/ld+json"]');
      if (oldScript) {
        oldScript.remove();
      }

      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.textContent = JSON.stringify(dataArray);
      document.head.appendChild(script);
    } catch (error) {
      console.error('更新Schema数据时出错:', error);
    }
  };

  const getCurrentSchemaData = (excludeType = 'Product'): any[] => {
    try {
      const script = document.querySelector('script[type="application/ld+json"]');
      if (!script || !script.textContent) {
        return [];
      }
      const data = JSON.parse(script.textContent);
      const result = Array.isArray(data) ? data : [data];
      return result.filter((item: any) => item['@type'] !== excludeType);
    } catch (error) {
      console.error('获取当前Schema数据时出错:', error);
      return [];
    }
  };

  const addSchema = (newData: any, excludeType = 'Product') => {
    try {
      // 确保 newData 是数组
      const dataToAdd = Array.isArray(newData) ? newData : [newData];

      // 验证新数据
      dataToAdd.forEach((item: any) => {
        if (!item['@context'] || !item['@type']) {
          console.warn('新增的Schema数据缺少必要属性');
          return;
        }

        // 处理日期
        if (item.datePublished instanceof Date) {
          item.datePublished = item.datePublished.toISOString();
        }
        if (item.dateModified instanceof Date) {
          item.dateModified = item.dateModified.toISOString();
        }
      });

      // 从 DOM 获取当前数据
      const currentData = getCurrentSchemaData(excludeType);

      // 合并数据
      const updatedData = [...currentData, ...dataToAdd];

      // 使用 updateSchema 更新合并后的数据
      updateSchema(updatedData);
    } catch (error) {
      console.error('添加Schema数据时出错:', error);
    }
  };

  return {
    schemaData,
    updateSchema,
    addSchema
  };
}
